import config from '@/i18next-options'

export default function normalizeLang(lang) {
  return config.allLanguages.includes(lang) ? lang : 'en'
}
